import { LicenseManager } from 'ag-grid-enterprise';

import { AG_GRID_LICENSE_KEY } from 'Constants/AgGridConstants';

LicenseManager.setLicenseKey(AG_GRID_LICENSE_KEY);
